import React from 'react';
import ExpensesByTypePage from './ExpensesByTypePage';
import { ExpenseType } from '../../types/homeExpenses';

const HomeExpensesPage: React.FC = () => (
  <ExpensesByTypePage expenseType={ExpenseType.Home} title="Despesas da casa" />
);

export default HomeExpensesPage;
